<template>
  <FormContainer :row="row" :gap="!noError">
    <FormLabel
      v-if="labelText || hasDefaultSlotValue"
      :id="id"
      :label-text="labelText"
      :error="!!errorMessage"
      :style="{ width: labelWidth ? `${labelWidth}%` : '' }"
      :class="{ 'form-label-row': row }"
    >
      <slot />
    </FormLabel>
    <BaseSelectDropdown
      :id="id"
      v-bind="$attrs"
      v-model="internalValue"
      :invalid="!!errorMessage"
      :style="{ width: inputWidth ? `${inputWidth}%` : '' }"
    >
      <slot />
    </BaseSelectDropdown>
    <template v-if="!noError" #bottomRow>
      <FormError :errorMessage="errorMessage" />
    </template>
  </FormContainer>
</template>

<script>
  import FormContainer from './FormContainer.vue';
  import FormLabel from './FormLabel.vue';
  import FormError from './FormError.vue';
  import BaseSelectDropdown from '~/components/base/BaseSelectDropdown.vue';

  export default {
    name: 'FormSelect',
    components: {
      FormContainer,
      FormLabel,
      FormError,
      BaseSelectDropdown,
    },
    props: {
      modelValue: {
        type: [Array, String, Number],
        required: false,
        default: null,
      },
      id: {
        type: String,
        required: true,
      },
      labelText: {
        type: String,
        required: false,
        default: '',
      },
      errorMessage: {
        type: String,
        required: false,
        default: '',
      },
      row: Boolean,
      noError: Boolean,
      widthSplit: {
        type: String,
        required: false,
        default: '1/3',
        validator: (value) => {
          const [numerator, denominator] = value.split('/');
          return numerator > 0 && denominator > 0;
        },
      },
    },
    computed: {
      internalValue: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        },
      },
      labelWidth() {
        if (!this.row) return '';
        const ratio = this.widthSplit.split('/');
        return (ratio[0] / ratio[1]) * 100;
      },
      inputWidth() {
        if (!this.row || !this.labelWidth) return '';
        return 100 - this.labelWidth;
      },
      hasDefaultSlotValue() {
        return Object.keys(this.$slots).includes('default');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-label-row {
    padding-right: 6px;
  }
</style>
